<script setup lang="ts"></script>

<template>
  <section>
    <v-container>
      <div class="public-map-loader">
        <img src="@/assets/images/map.webp" alt="vector-world-map" />
      </div>
    </v-container>
  </section>
</template>

<style lang="scss" scoped>
.public-map-loader {
  display: flex;
  justify-content: center;
  margin-bottom: 150px;

  img {
    max-width: 100%;
    height: auto;
    object-fit: contain;
  }
}
</style>
